import TouchGallery from "./TouchGallery";

export function handleProductGallery($element) {
    new TouchGallery($element, {
        itemsClass: "product-gallery__slides",
        itemClass: "product-gallery__image",
        pipClass: "product-gallery__pip",
        keyboardEvents: true,
        animationDuration: () => {
            return $(window).outerWidth() >= 1024 ? 600 : 300;
        },
        zoom: {
            enabled: true,
        },
    });
}